import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type TabUILeaderCallState = 'Idle' | 'Joining' | 'Connected' | 'ACW'

const initialState = {
  showCCP: true,
  isLeader: false,
  leaderCallState: 'Idle' as TabUILeaderCallState,
}

const tabUISlice = createSlice({
  name: 'tabUI',
  initialState,
  reducers: {
    toggleCCP: (state) => {
      state.showCCP = !state.showCCP
    },
    setShowCCP: (state, action: PayloadAction<boolean>) => {
      state.showCCP = action.payload
    },
    setLeader: (state, action: PayloadAction<boolean>) => {
      state.isLeader = action.payload
    },
    setLeaderCallState: (state, action: PayloadAction<TabUILeaderCallState>) => {
      state.leaderCallState = action.payload
    },
  },
})

export const { toggleCCP, setShowCCP, setLeader, setLeaderCallState } =
  tabUISlice.actions
export default tabUISlice.reducer
